<template lang="pug">
.splashScreen(:class='delayClasses')
  .center
    img(src='static/logo.png')
    p
      template(v-if="isInitialized && isConnected") {{$t('home.groupsLoading')}}
      template(v-else) {{$t('globals.loading')}}
    i.fa.fa-spin.fa-refresh

</template>
<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      delayClasses: this.getCurrentClasses()
    }
  },
  computed: {
    ...mapGetters('user', [
      'isInitialized',
      'isConnected'
    ]),
    ...mapGetters('groops', [
      'groopsAreLoaded'
    ]),
    classes () {
      return this.getCurrentClasses()
    }
  },
  methods: {
    getCurrentClasses () {
      if (this.isInitialized && (!this.isConnected || this.groopsAreLoaded)) {
        return 'loaded'
      }
    }
  },
  watch: {
    classes () {
      setTimeout(() => {
        this.delayClasses = this.classes
      }, 500)
    }
  }
}
</script>
<style lang="sass">
.splashScreen
  background-color: #3498DB
  z-index: 99999999
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  .center
    position: absolute
    text-align: center
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    color: white
    img
      width: 50px
  &.loaded
    transition: opacity 0.1s ease 1s, top 1s ease, bottom 1s ease
    pointer-events: none
    bottom: 100vh
    top: -100vh
    opacity: 0
      
</style>



// WEBPACK FOOTER //
// SplashScreen.vue?52c79dfe